import Button from "./Components/Button"

export default function NavLayer2({ texts = [], hrefs = [], activeIndex = 0, className = "" }) {
  const count = texts.length;
  const maxWidth = count * 150 + (count - 1) * 4;
  
  return (
    <div className="w-full flex justify-center items-center">

      <div
        className={`w-full max-w-full flex gap-1 rounded-[10px] border border-zi-border-dark dark:border-transparent bg-zi-bg2-light dark:bg-zi-bg2-dark p-0.5 overflow-auto mb:max-w-[var(--nav-max-width)] ${className}`}
        style={{ "--nav-max-width": `${maxWidth}px` }}
      >
        {texts.map((text, index) => (
          <Button
            key={index}
            text={text}
            href={hrefs[index]}
            active={index === activeIndex}
          />
        ))}
      </div>

    </div>
  );
}
